import ga from '../utils/ga'
import { IExperimentsState, IExperimentState } from '../reducers/experiments'

export const reportExperimentsEnrolments = (
  experimentsState: IExperimentsState,
  isOptimizeDisabled?: boolean
) => {
  const isExperimentEntry = (
    entry: [string, any]
  ): entry is [string, IExperimentState] => {
    return (
      entry[1] &&
      Object.hasOwnProperty.call(entry[1], 'variant') &&
      Object.hasOwnProperty.call(entry[1], 'isLoadingVariant')
    )
  }
  const experimentsList = Object.entries(experimentsState)
    .filter(isExperimentEntry)
    .map(([key, value]) => `${key}.${value.variant}`)

  if (isOptimizeDisabled) {
    experimentsList.push('optimizeDisabled.0')
  }

  if (experimentsList.length) {
    const experimentsString = experimentsList.join('!')
    ga('set', 'exp', experimentsString)
    ga('set', 'dimension21', experimentsString)
    ga('set', 'dimension22', experimentsString)
  }
}
